import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { filter, merge, Observable } from 'rxjs';
import { Store } from '@ngrx/store';

import * as UiActions from '../../state/ui/ui.actions';
import * as UiSelectors from '../../state/ui/ui.selectors';
import * as ListsSelectors from '../../../lists/state/selectors/lists.selectors';
import * as fromTrace from '../../../trace/state/trace.reducer';
import { MainNavMenuItem } from 'types-unicorn';
import { AuthFacade } from 'auth-unicorn';
import { Router } from '@angular/router';

@Component({
  selector: 'admin-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LayoutComponent implements OnInit {

  menuOpen$!: Observable<boolean>;
  menuItems$!: Observable<MainNavMenuItem[]>;
  globalLoading$!: Observable<boolean>;
  currentUserFullName$!: Observable<string>;

  constructor(private store: Store,
              private auth: AuthFacade,
              private router: Router) { }

  ngOnInit() {
    this.connectStoreObservables();
    this.connectAuthObservables();
    this.globalLoading$ = merge(
      this.store.select(ListsSelectors.selectLoading),
      this.store.select(fromTrace.selectLoading)
    );
  }

  onOpenMenu(): void {
    this.store.dispatch(UiActions.ToggleSideMenu());
  }

  onLogout(): void {
    this.auth.logout();
  }

  private connectStoreObservables() {
    this.menuOpen$ = this.store.select(UiSelectors.selectMenuOpen);
    this.menuItems$ = this.store.select(UiSelectors.selectMainNavMenuItems).pipe(
      filter(items => items.length > 0)
    );
  }

  private connectAuthObservables() {
    this.currentUserFullName$ = this.auth.currentUserFullName();
  }

  onChangePassword() {
    this.auth.changePassword();
  }

  onShowProfile() {
    this.router.navigate(['my-profile'])
  }
}
